import { Box, Typography } from "@mui/material";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { useContext, useEffect, useState } from "react";
import ConfirmationModal from "@/modules/common/components/modals/cofirmation-modal";
import { toast } from "react-toastify";
import { queryClient } from "@/queryClient";
import useArchiveLead from "@/modules/lead-page/hooks/lead-info/lead-actions/archive-lead.hook";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const ArchiveLead = () => {
  const { lead } = useContext(LeadPageContext);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const { handleArchiveLead, isLoading, isError, isSuccess } = useArchiveLead();

  useEffect(() => {
    const hasError = Object.values(isError).some((value) => value === true);
    if (hasError) {
      toast.error("Something went wrong", {
        position: "bottom-left",
        autoClose: 3000,
      });
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      queryClient.invalidateQueries({
        queryKey: ["getLead"],
      });
      toast.success(
        lead?.data?.lead?.archived === false
          ? "Lead archived successfully"
          : "Lead Un-archived successfully",
        {
          position: "bottom-left",
          autoClose: 2000,
        }
      );

      {
        lead?.data?.lead?.archived === false &&
          (window.location.href = "/leads");
      }
      setConfirmationModal(false);
    }
  }, [isSuccess]);

  return (
    <>
      <ConfirmationModal
        open={confirmationModal}
        setOpen={setConfirmationModal}
        onConfirmHandler={handleArchiveLead}
        title={lead?.data?.lead?.archived ? "Unarchive Lead" : "Archive Lead"}
        body={
          lead?.data?.lead?.archived
            ? "Are you sure you want to unarchive this lead?"
            : "Are you sure you want to archive this lead?"
        }
        isLoading={isLoading}
      />
      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          ":hover": {
            backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
          },
        }}
        onClick={() => setConfirmationModal(true)}
      >
        <Typography
          sx={{
            color: lead?.data?.lead?.archived
              ? nawyTheme.nawy.colors.semantic.text.extension.positive
              : nawyTheme.nawy.colors.semantic.text.extension.negative,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          {lead?.data?.lead?.archived ? "Unarchive Lead" : "Archive Lead"}
        </Typography>
      </Box>
    </>
  );
};

export default ArchiveLead;
